import { firestore, firebase } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getSuggestionKey from '../utilities/Data/Kit/getSuggestionKey'

const deleteKitSuggestion = async ({ uid, kitId, itemKey, colourName }) => {
	try {
		const ref = firestore.collection('kits').doc(kitId).collection('suggestions').doc(uid)
		return await ref.set({
			items: {
				[getSuggestionKey({ itemKey, colourName })]: firebase.firestore.FieldValue.delete()
			}
		}, { merge: true })
	} catch (error) {
		return Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, kitId, error))
	}
}
export default deleteKitSuggestion



// WEBPACK FOOTER //
// ./src/dataservices/deleteKitSuggestion.js